'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_DefaultSort(direction) {
  this.Sg = null;
  this.Sg = direction;
}
export { $c_Lmealorama_DefaultSort as $c_Lmealorama_DefaultSort };
$p = $c_Lmealorama_DefaultSort.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_DefaultSort;
/** @constructor */
function $h_Lmealorama_DefaultSort() {
}
export { $h_Lmealorama_DefaultSort as $h_Lmealorama_DefaultSort };
$h_Lmealorama_DefaultSort.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 1018484691, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_DefaultSort)) {
    var x = this.Sg;
    var x$2 = x$0.Sg;
    return ((x === null) ? (x$2 === null) : (x === x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "DefaultSort";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.Sg;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_DefaultSort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jt)));
}
export { $isArrayOf_Lmealorama_DefaultSort as $isArrayOf_Lmealorama_DefaultSort };
var $d_Lmealorama_DefaultSort = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_DefaultSort, "mealorama.DefaultSort", ({
  jt: 1,
  eK: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_DefaultSort as $d_Lmealorama_DefaultSort };
//# sourceMappingURL=mealorama.-Default-Sort.js.map
